import ApiService from '../api.services';

const CallCenterService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/callcenters');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/callcenters/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        try {
            const data = {
                callcenter: form
            }
            const res = await ApiService.post('/api/callcenters', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            callcenter: form
        }
        try {
            const response = await ApiService.put(`/api/callcenters/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/callcenters/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default CallCenterService;

export { CallCenterService };

